import { inject, Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { mergeMap, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { ReportsVisualizationsHttpClient } from './visualizations.http-client';
import { ReportsVisualizationsActions } from './visualizations.store';

@Injectable()
export class ReportsVisualizationsEffects {
  private readonly actions$ = inject(Actions);
  private readonly http = inject(ReportsVisualizationsHttpClient);

  public effects = createEffectFactory(ReportsVisualizationsActions, this.actions$);

  public fetchVisualization$ = this.effects(
    ReportsVisualizationsActions.fetchOneVisualization,
    ({ payload }) =>
      this.http.load(payload.data.kind, payload.data.params).pipe(
        map(response =>
          ReportsVisualizationsActions.fetchOneVisualizationSuccess({
            payload: {
              correlationId: payload.data.paramsHash,
              data: {
                paramsHash: payload.data.paramsHash,
                response,
              },
            },
          }),
        ),
        catchError(err =>
          of(
            ReportsVisualizationsActions.fetchOneVisualizationFailed({
              payload: {
                correlationId: payload.data.paramsHash,
                data: {
                  paramsHash: payload.data.paramsHash,
                  error: {
                    status: err.status,
                    message: err.message,
                  },
                },
              },
            }),
          ),
        ),
      ),
    { customMapOperator: mergeMap },
  );
}
